<template>
  <!-- ホーム画面 -->
  <div id="Home" :key="healthCheck">
    <template v-if="loginType==1">
      <admin />
    </template>
    <template v-else-if="loginType==2">
      <callCenter v-bind:health-check="healthCheck"/>
    </template>
    <template v-else-if="loginType==3 && userInfo.srcRoleId!=5">
      <inspectorAdmin v-bind:health-check="healthCheck"/>
    </template>
    <template v-else-if="loginType==4">
      <inspector v-bind:health-check="healthCheck"/>
    </template>
    <template v-else-if="loginType==7 || userInfo.srcRoleId==5">
      <urgentScheduleOnly v-bind:health-check="healthCheck"/>
    </template>
    <template v-else></template>
    <b-modal :active.sync="healthCheckActive" has-modal-card>
      <healthcheck-modal v-on:child-event="setStatus" @close="closeModal"></healthcheck-modal>
    </b-modal>
  </div>
</template>

<script>
import adminTemplate from "./AdminHome";
import callCenterTemplate from "./CallCenterHome";
import inspectorAdminTemplate from "./InspectorAdminHome";
import inspectorTemplate from "./InspectorHome";
import urgentScheduleOnlyTemplate from "./UrgentScheduleOnlyHome";

const HealthcheckForm = {
  props: [],
  data() {
    return {
      status: ""
    };
  },
  methods: {
    inputAnswerYes: function(event) {
      // 健康状態をDBへ更新
      this.status = 1;
      this.$parent.$parent.userInfo.healthCheckFlg = 1
      sessionStorage.setItem('userInfo', JSON.stringify(this.$parent.$parent.userInfo))
      this.key = this.key ? 0 : 1;
      var excuteApi = this.setHealthCheckPOST;
      var successCallBack = this.setHealthCheckPOSTSuccess;
      var errorCallBack = this.setHealthCheckPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
      this.$emit("child-event", "1");
      this.$parent.close();
    },
    inputAnswerNo: function(event) {
      this.status = 0;
      this.$parent.$parent.userInfo.healthCheckFlg = 0
      sessionStorage.setItem('userInfo', JSON.stringify(this.$parent.$parent.userInfo))
      this.key = this.key ? 0 : 1;
      var excuteApi = this.setHealthCheckPOST;
      var successCallBack = this.setHealthCheckPOSTSuccess;
      var errorCallBack = this.setHealthCheckPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
      this.$emit("child-event", "0");
      this.$parent.close();
    },
    setHealthCheckPOST: function(client) {
      return client.apis.apiCommon.setHealthCheckPOST({
        body: {
          healthStatus: this.status
        }
      });
    },
    setHealthCheckPOSTSuccess: function(result) {
      // 処理なし
    },
    setHealthCheckPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  template: `
        <div class="modal-card" style="width: 500px;">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">ヘルスチェック</p>
          </header>
          <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
            <div>
              <p>健康状態に問題はないですか？</p>
            </div>
          </section>
          <footer class="modal-card-foot">
            <div>
            <b-button
              class="button is-primary is-inverted has-text-centered"
              icon-left="thumb-up-outline"
              type="button"
              v-on:click="inputAnswerYes"
            >
            はい
            </b-button>
            <b-button
              class="button is-light is-inverted has-text-centered"
              icon-left="thumb-down-outline"
              v-on:click="inputAnswerNo"
            >いいえ</b-button>
            </div>
          </footer>
        </div>
      `
};

export default {
  name: "Home",
  methods: {
    setStatus: function(val) {
      this.healthCheck = val;
    },
    closeModal: function(event) {
      this.healthCheckActive = false;
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var loginType = userInfo.roleId;
    if (userInfo.healthCheckFlg == null || userInfo.healthCheckFlg ==0) {
      var healthCheckActive = false;
      if (!(loginType === undefined) && loginType >= 2) {
        // 初回ログイン時
        healthCheckActive = true;
      }
    }
    return {
      userInfo,
      loginType: loginType,
      healthCheckActive: healthCheckActive,
      healthCheck: userInfo.healthCheckFlg
    };
  },
  components: {
    admin: adminTemplate,
    callCenter: callCenterTemplate,
    inspectorAdmin: inspectorAdminTemplate,
    inspector: inspectorTemplate,
    urgentScheduleOnly: urgentScheduleOnlyTemplate,
    "healthcheck-modal": HealthcheckForm
  }
};
</script>

<style lang="scss">
.messageSpace {
  padding: 0.5em 1em;
  margin: 2em 0;
  color: #5d627b;
  background: white;
  border-left: solid 5px #5d627b;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.22);
  text-align: left;
}
.messageSpace p {
  margin: 0;
  padding: 0;
}
.alert {
  padding: 0.5em 1em;
  margin: 2em 0;
  color: #232323;
  background: #fadbda;
  border-left: 6px solid #ff3860;
  text-align: left;
}
.alert p {
  font-weight: normal;
  margin: 0;
  padding: 0;
}
.notice {
  padding: 0.25em 0 0.25em 0.75em;
  border-left: 6px solid #209cee;
  text-align: left;
}
.schedule {
  padding: 0.25em 0 0.25em 0.75em;
  border-left: 6px solid #061e57;
  text-align: left;
}
.reservationToday {
  padding: 0.25em 0 0.25em 0.75em;
  border-left: 6px solid #23d160;
  text-align: left;
}
.reservationTomorrow {
  padding: 0.25em 0 0.25em 0.75em;
  border-left: 6px solid #878d99;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue